export default {
  apiUrl: '/api/',
  pubApiUrl: '/api/pub/'
};